import React, { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogAutoCompleteVehicleControlled from '@/main/components/shared/inputAutoComplete/autoCompleteVehicleControlled';

import { KeyValue } from '@/main/models/common';
import { getTranslateByKey, isNullUndefined, isValueQueryParams } from '@/main/services/utils';
import { getManufacturers, resetReducerManufacturers, useManufacturerReducer } from '@/main/store/vehicle/manufacturer';
import { getModels, resetReducerModels, useModelReducer } from '@/main/store/vehicle/model';
import { useDinamicFiltersMappingCodes } from './dinamicFiltersMappingCodes';


export const INITIAL_FORM_STATE_MODEL = {
  manufacturer: null as KeyValue | null,
  model: null as KeyValue | null,
};

export type IFormFiltersMappingTypeModel = typeof INITIAL_FORM_STATE_MODEL

interface IFiltersMappingTypeModelProps { }

function FiltersMappingTypeModel({
}: IFiltersMappingTypeModelProps) {
  const dispatch = useDispatch();
  const {
    isEdit,
    keyReducer,
    watcherCountry,
    isRequiredField
  } = useDinamicFiltersMappingCodes();
  const { isolated: manufacturerReducer } = useManufacturerReducer(keyReducer);
  const { isolated: modelsReducer } = useModelReducer(keyReducer);
  const {
    control,
    setValue,
    resetField,
    watch
  } = useFormContext<IFormFiltersMappingTypeModel>();

  const watcherManufacturer = watch('manufacturer');

  useEffect(() => {
    if (!isValueQueryParams(watcherCountry)) {
      resetField('manufacturer');
    }
    if (!isValueQueryParams(watcherCountry)) {
      resetField('model');
    }
    if (isNullUndefined(watcherCountry)) return;

    dispatch(getManufacturers({ guidCountry: String(watcherCountry.key) }, keyReducer));

    return () => {
      dispatch(resetReducerManufacturers(keyReducer));
      dispatch(resetReducerModels(keyReducer));
    }
  }, [JSON.stringify(watcherCountry?.key)])

  useEffect(() => {
    if (watcherCountry?.key && watcherManufacturer?.key) {
      dispatch(resetReducerModels(keyReducer));
      resetField('model');
      dispatch(getModels({ guidCountry: String(watcherCountry?.key), guidManufacturer: String(watcherManufacturer?.key) }, keyReducer));
    }
  }, [watcherCountry?.key, watcherManufacturer?.key,])

  const disabledManufacturer = isNullUndefined(manufacturerReducer.data) || manufacturerReducer.data.length === 1
  const disabledModel = isNullUndefined(modelsReducer.data) || modelsReducer.data.length === 1
  return (
    <>
      {
        <KogAutoCompleteVehicleControlled
          id='id-mappingCode-select-manufacturer'
          nameCustom='manufacturer'
          label={getTranslateByKey('information.manufacturer')}
          isDefaultValueUnique
          control={control}
          setValueCustom={setValue}
          options={manufacturerReducer.data}
          isLoading={manufacturerReducer.isLoading}
          disabled={disabledManufacturer}
          rulesCustom={{ required: isRequiredField('manufacturer') }}
          onChangeCustom={() => { }}
        />

      }
      <KogAutoCompleteVehicleControlled
        id='id-mappingCode-select-model'
        nameCustom='model'
        label={getTranslateByKey('information.model')}
        isDefaultValueUnique
        control={control}
        setValueCustom={setValue}
        options={modelsReducer.data}
        isLoading={modelsReducer.isLoading}
        disabled={disabledModel}
        rulesCustom={{ required: isRequiredField('model') }}
        onChangeCustom={() => { }}
      />
    </>
  )
}

export default FiltersMappingTypeModel